import "./Services.css";
import appartementImg from "../../assets/nottoyage-bureau.jpg";
import bureauImg from "../../assets/nettoyage-maison.jpg";
import travauxImg from "../../assets/nettoyage-chantier.jpg";
import immeubleImg from "../../assets/nettoyage-vitre.jpg";
import immeuble from "../../assets/nettoyage-cabine.jpg"
export default function Services() {
  const data = [
    { title: "Nettoyage de bureaux", desc: "Entretien complet des espaces de travail, sols, surfaces et sanitaires.", img: bureauImg },
    { title: "Netoyage \n d'appartements et maisons", desc: "Entretien complet des sols, surfaces et sanitaires.", img: appartementImg },
    { title: "Nettoyage après chantier", desc: "Débarras, dépoussiérage complet, vitres et finitions professionnelles.", img: travauxImg },
    { title: "Nettoyage des vitres", desc: "Vitres intérieures et extérieures avec matériel professionnel.", img: immeubleImg },
    { title: "Entretien de Copropriété", desc: "Nous assurons l’entretien complet des copropriétés avec un service sérieux, régulier et adapté aux besoins de chaque résidence. \nNos interventions comprennent :\n •	Nettoyage des halls, escaliers, paliers et ascenseurs\n • Lavage et entretien des sols\n •	Sortie et rentrée des containers\n •	Nettoyage des parkings, caves et locaux commun\n •	Lavage des vitres\n •	Entretien des espaces extérieurs\n •	Petites interventions et vérifications courantes", img: immeuble }

  ];

//   Entretien de Copropriété

// Nous assurons l’entretien complet des copropriétés avec un service sérieux, régulier et adapté aux besoins de chaque résidence.

// Nos interventions comprennent :
// 	•	Nettoyage des halls, escaliers, paliers et ascenseurs
// 	•	Lavage et entretien des sols
// 	•	Sortie et rentrée des containers
// 	•	Nettoyage des parkings, caves et locaux communs
// 	•	Lavage des vitres
// 	•	Entretien des espaces extérieurs
// 	•	Petites interventions et vérifications courantes

// Nous garantissons un travail propre, régulier et professionnel pour maintenir votre copropriété dans un état impeccable.

  return (
    <section id="services" className="services container">
      <h2 className="section-title">Nos <span className="yellow">services</span></h2>

      <div className="service-grid">
        {data.map((s, i) => (
          <div className="card" key={i} style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${s.img})` }}>
            <h3>{s.title}</h3>
            <p>{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
